module.exports = __webpack_public_path__ + "assets/img/inetum_b.a954616c.png";